<app-document-subheader />

@let workSchedule = this.workSchedule$ | async;

<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (workSchedule) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">

                <div class="row mb-2">
                  <div class="col-12 col-md-9 mr-auto">
                    <div class="form-group">
                      <label class="form-title-label" translate>WORK_SCHEDULE_LBL_NAME</label>
                      <div class="form-title">{{ workSchedule.name }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>WORK_SCHEDULE_LBL_ACTIVE</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          <input type="checkbox" [checked]="workSchedule.active" disabled />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12">
                    <label class="col-form-label-sm" translate>WORK_SCHEDULE_LBL_DAYS</label>
                    <app-work-schedule-week [days]="workSchedule.days" />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (workSchedule) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'WorkSchedule'"
          [entityId]="workSchedule.id.toString()"
        />
      </div>
    }
  </div>
</div>
